// ** React Imports
import { createContext, useState } from 'react'
import PropTypes from 'prop-types';

// ** Create Context
export const CreatePollContext = createContext({
    pollId: '',
    pollQuestion: '',
    pollOptions: [],
    imgSrc: '',
    imgFile: undefined,
    groupsCanVote: false,
    hasVoteFee: false,
    isValidVoteFee: false,
    voteFee: '',
    hasExpireDate: false,
    isValidExpireDate: false,
    expireDate: '',
    setGroupsCanVote: (/** @type {Boolean} */ _) => { _ },
    setHasVoteFee: (/** @type {Boolean} */ _) => { _ },
    setIsValidVoteFee: (/** @type {Boolean} */ _) => { _ },
    setVoteFee: (/** @type {string} */ _) => { _ },
    setHasExpireDate: (/** @type {Boolean} */ _) => { _ },
    setIsValidExpireDate: (/** @type {Boolean} */ _) => { _ },
    setExpireDate: (/** @type {string} */ _) => { _ },
    setPollId: (/** @type {string} */ _) => { _ },
    setPollQuestion: (/** @type {string} */ _) => { _ },
    setPollOptions: (/** @type {string[]} */ _) => { _ },
    setImgSrc: (/** @type {string} */ _) => { _ },
    setImgFile: (/** @type {any} */ _) => { _ },
})

export const CreatePollProvider = ({ children }) => {
    // ** State
    const [pollId, setPollId] = useState('');
    const [pollQuestion, setPollQuestion] = useState('');
    const [pollOptions, setPollOptions] = useState([]);
    const [imgSrc, setImgSrc] = useState('');
    const [imgFile, setImgFile] = useState();
    const [groupsCanVote, setGroupsCanVote] = useState(true);
    const [hasVoteFee, setHasVoteFee] = useState(false);
    const [isValidVoteFee, setIsValidVoteFee] = useState(false);
    const [voteFee, setVoteFee] = useState('');
    const [hasExpireDate, setHasExpireDate] = useState(false);
    const [isValidExpireDate, setIsValidExpireDate] = useState(false);
    const [expireDate, setExpireDate] = useState('');


    return <CreatePollContext.Provider value={{
        pollId, setPollId, pollQuestion, setPollQuestion, pollOptions, setPollOptions, imgSrc, setImgSrc, imgFile, setImgFile,
        groupsCanVote, setGroupsCanVote,
        hasVoteFee, setHasVoteFee,
        isValidVoteFee, setIsValidVoteFee,
        voteFee, setVoteFee,
        hasExpireDate, setHasExpireDate,
        isValidExpireDate, setIsValidExpireDate,
        expireDate, setExpireDate
    }}>{children}</CreatePollContext.Provider>
}

CreatePollProvider.propTypes = {
    children: PropTypes.element
}

export const CreatePollConsumer = CreatePollContext.Consumer
